import React, { useState } from "react";

const IconPowerBI = ({
  size = 16,
  stroke = 2,
  color = "currentColor",
  hoverColor = "#1890ff",
  marginRight = 8,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke={isHovered ? hoverColor : color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        transition: "stroke 0.5s ease, fill 0.5s ease",
        marginRight: `${marginRight}px`,
        marginBottom: "-4px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <title>powerbi</title>
      <path
        d="M13.501 16h-7.498c0 0-0 0-0 0-0.69 0-1.25 0.559-1.25 1.25v12.496c0 0.69 0.559 1.25 1.25 1.25h8.747v-13.746c0-0.69-0.559-1.25-1.25-1.25zM19.749 8.502h-7.498c-0.69 0-1.25 0.559-1.25 1.25v5.623h2.499c1.035 0.001 1.873 0.84 1.874 1.874v13.746h5.623v-21.244c0-0.69-0.559-1.25-1.25-1.25zM27.247 2.254v27.492c0 0.69-0.559 1.25-1.25 1.25h-4.374v-21.244c-0.001-1.035-0.84-1.873-1.874-1.874h-2.499v-5.623c0-0.69 0.559-1.25 1.25-1.25h7.498c0.69 0 1.25 0.559 1.25 1.25z"
        fill="none"
      />
    </svg>
  );
};

export default IconPowerBI;
